'use strict'

define ['./userAddModal.scss'], () ->
  ($scope, $rootScope, $uibModalInstance, $cacheFactory, $http, RENTAPPLICATION_API_URL, Flash, $window) ->
    $scope.theme_color = $rootScope.THEME_COLOR
    $scope.adding_user = false

    # Default settings for adding new users
    $scope.is_agent = true
    $scope.can_create = false
    $scope.show_my_payments = false
    $scope.show_accept_reject_button = false
    $scope.copy_settings = false
    $scope.create_default_apptemplate = false
    $scope.default_apptemplate_slug = ""

    validator = require('validator');

    $scope.update_default_apptemplate_slug = () ->
      if not $scope.default_apptemplate_slug
        $scope.default_apptemplate_slug = $scope.name.toLowerCase().split(" ").join("-")
    
    # This is required as input ng-model is 
    # not working for some reason
    $scope.model_default_apptemplate_slug = () ->
      $scope.default_apptemplate_slug = event.target.value

    $scope.add_user = ->
      if $scope.companiesForm.$invalid
        if $scope.companiesForm['email'].$error
          $scope.error_message = "Email address required"
        if $scope.companiesForm['name'].$error
          $scope.error_message = "Name required"
        return
      
      if !validator.isEmail($scope.email)
        $scope.error_message = "Please enter a valid email address"
        return 

      $scope.adding_user = true
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/company/#{$scope.current_company.id}/create_company_membership_with_new_landlord/",
        username: $scope.email
        name: $scope.name
        phone: $scope.phone
        is_agent: $scope.is_agent
        can_create: $scope.can_create
        show_my_payments: $scope.show_my_payments
        show_accept_reject_button: $scope.show_accept_reject_button
        copy_settings: $scope.copy_settings
        create_default_apptemplate: $scope.create_default_apptemplate
        default_apptemplate_slug: $scope.default_apptemplate_slug
      .then (response) ->
        console.log(response)
      .catch (err) ->
        Flash.create('danger',  err.data.error , 3000, { class: 'error' }, true)
        $window.scrollTo(0, 0)
      .finally ->
        $scope.adding_user = false
        $uibModalInstance.close()



// WEBPACK FOOTER //
// ./components/dashboard/settings/company/userAddModal/userAddModal.coffee